import { useEffect, useState } from "react";
import {
  Button,
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  Icon,
} from "~/components/ui";
import { BASE_URL } from "~/lib/config/constants";
import { getConfig } from "~/lib/config/env";

interface Props {
  isOpen: boolean;
  onClose: () => void;
}

interface ApiMeta {
  version: string;
}

export default function AppInfoModal(props: Props) {
  const [apiMeta, setApiMeta] = useState<ApiMeta | null>(null);

  useEffect(() => {
    if (!props.isOpen) return;

    const fetchMeta = async () => {
      try {
        const res = await fetch(`${BASE_URL()}/api/v1/meta/info`);
        if (res.ok) {
          const data = await res.json();
          const meta = data.result || data;
          setApiMeta({
            version: meta.version || meta.Version || "",
          });
        }
      } catch {
        setApiMeta(null);
      }
    };

    fetchMeta();
  }, [props.isOpen]);

  const clientVersion = getConfig().version;

  return (
    <Dialog onOpenChange={props.onClose} open={props.isOpen}>
      <DialogContent
        className="max-w-200 w-[512px]"
        style={{ borderRadius: "16px" }}
        noClose
      >
        <DialogHeader>
          <DialogTitle className="flex items-center justify-between">
            <h1 className="font-Medium text-lg">App Info</h1>
            <Icon name="X" size={20} onClick={props.onClose} />
          </DialogTitle>
        </DialogHeader>
        <div className="space-y-4 py-2">
          <div className="grid grid-cols-2 gap-4">
            {clientVersion && (
              <div>
                <h1 className="font-Medium text-sm text-neutral-400">
                  Client Version
                </h1>
                <p className="font-Regular text-sm text-primary-500">
                  {clientVersion}
                </p>
              </div>
            )}
            {apiMeta?.version && (
              <div>
                <h1 className="font-Medium text-sm text-neutral-400">
                  API Version
                </h1>
                <p className="font-Regular text-sm text-primary-500">
                  {apiMeta.version}
                </p>
              </div>
            )}
          </div>
        </div>
        <DialogFooter>
          <Button type="submit" onClick={props.onClose}>
            Close
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
